import { FC } from "react"
import { IOrder, ISupply } from "../../../app/reducers/ordersReducer"
import s from "../NewOrders.module.css"
import { Button } from "@radix-ui/themes"
import { DataTable, type DataTableColumn } from "../../DataTable/DataTable"
import { Select } from "../../Select/Select"

type CreateNewSuppliesProps = {
  orders: IOrder[]
  supplies: ISupply[]
  lastDateUpdatedSupplies?: string
  updateSupplies: () => void
  selectedSupply: string
  setSelectedSupply: (supp: string) => void
}

export const AddToSupplies: FC<CreateNewSuppliesProps> = ({
  orders,
  supplies,
  lastDateUpdatedSupplies,
  updateSupplies,
  selectedSupply,
  setSelectedSupply,
}) => {
  const columns: DataTableColumn<IOrder>[] = [
    { key: "id", header: "№ задания" },
    {
      key: "createdAt",
      header: "Создано",
      cell: (el) => new Date(el.createdAt).toLocaleString(),
    },
    { key: "warehouseId", header: "Склад" },
    { key: "article", header: "Артикул продавца" },
    { key: "nmId", header: "Артикул WB" },
    {
      key: "convertedPrice",
      header: "Цена",
      cell: (el) => +el.convertedPrice / 100,
    },
  ]

  return (
    <div>
      <div>
        <div>
          <div>
            <Select
              value={selectedSupply}
              onChange={(value) => {
                setSelectedSupply(value)
              }}
              options={supplies.map((storage) => ({
                value: String(storage.id),
                label: storage.name,
              }))}
              placeholder="Выбрать поставку"
              clearable
            />
            <Button className={s.updateSupplies} onClick={updateSupplies}>
              Обновить поставки
              {lastDateUpdatedSupplies &&
                ` (обновлено: ${lastDateUpdatedSupplies})`}
            </Button>
          </div>
        </div>
        <div>
          <h5>Выбранные позиции</h5>
          <DataTable
            columns={columns}
            data={orders}
            rowKey={(el, i) => el.article + "-add-" + i}
          />
        </div>
      </div>
    </div>
  )
}
